<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="8" sm="8">
        <v-text-field v-model="queryForm.name" label="充电桩" outlined dense clearable hide-details
          @keyup.enter="getdata()" />
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd">
            <v-icon small>mdi-plus</v-icon> 新增充电桩
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="location" slot-scope="text, record">
          <p>{{ record.location.address }}</p>
          <p v-if="record.location.longitude">{{ record.location.longitude }},{{ record.location.latitude }}</p>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="primary" @click="showprice(record)"> 电费设置 </v-btn>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除充电桩" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
        <template slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-table size="small" :columns="sheaders" :data-source="record.items" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" :scroll="{ x: swidth }" row-key="_id">
            <template slot="index" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>
            <template slot="type" slot-scope="text, record">
              {{ getTypeText(record.type) }}
            </template>
            <template slot="action" slot-scope="text, record">
              <a-space>
                <a href="javascript:void(0);" @click="editprice(record)">编辑</a>
                <a href="javascript:void(0);" class="cyan--text" @click="copyprice(record._id)"> 复制 </a>
                <a href="javascript:void(0);" class="red--text" @click="removeprice(record._id)"> 删除 </a>
              </a-space>
            </template>
          </a-table>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="500px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.name" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      名称 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.max_power" type="number" :rules="[vrules.required]" suffix="kW" outlined
                    dense>
                    <template v-slot:label>
                      最大功率 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="form.count" type="number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      数量 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.location.address" rows="2" outlined dense>
                    <template v-slot:label>
                      位置
                    </template>
                    <template v-slot:append-outer>
                      <v-btn fab x-small @click="chooseLocation">
                        <v-icon dark>mdi-map-marker</v-icon>
                      </v-btn>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.location.longitude" outlined dense>
                    <template v-slot:label>
                      经度
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.location.latitude" outlined dense>
                    <template v-slot:label>
                      纬度
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.linkman" outlined dense>
                    <template v-slot:label>
                      联系人
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.linkphone" outlined dense>
                    <template v-slot:label>
                      联系方式
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" rows="2" outlined dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="pricemodel" persistent max-width="500px">
      <v-form ref="priceform" v-model="pricevalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ pricemodeltitle }}
            <v-icon @click="cancelsaveprice">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="12" md="6">
                  <v-select v-model="priceform.type" :items="price_types" :rules="[vrules.required]" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无">
                    <template v-slot:label>
                      类型 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="priceform.time_range" outlined dense>
                    <template v-slot:label>
                      时间段
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="priceform.price" outlined dense>
                    <template v-slot:label>
                      电费(kWh/元)
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="priceform.service_price" outlined dense>
                    <template v-slot:label>
                      服务费(kWh/元)
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="saveprice">确定</v-btn>
            <v-btn tile @click="cancelsaveprice">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import { message } from "ant-design-vue";
export default {
  name: "ChargingPile",
  data() {
    return {
      queryForm: {
        name: ""
      },
      price_types: [
        { text: '峰段', value: 'peak' },
        { text: '平段', value: 'flat' },
        { text: '谷段', value: 'valley' },
        { text: '尖峰段', value: 'sh_peak' },
      ],
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 120, align: "center" },
        { title: "最大功率", dataIndex: "max_power", scopedSlots: { customRender: "max_power" }, width: 100, align: "center" },
        { title: "数量", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 80, align: "center" },
        { title: "位置", dataIndex: "location", scopedSlots: { customRender: "location" }, width: 150, align: "center" },
        { title: "联系人", dataIndex: "linkman", scopedSlots: { customRender: "linkman" }, width: 100, align: "center" },
        { title: "联系方式", dataIndex: "linkphone", scopedSlots: { customRender: "linkphone" }, width: 100, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 120, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      sheaders: [
        { title: "类型", dataIndex: "type", scopedSlots: { customRender: "type" }, width: 120, align: "center" },//峰平谷电价
        { title: "时间段", dataIndex: "time_range", scopedSlots: { customRender: "time_range" }, width: 120, align: "center" },
        { title: "电价", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 120, align: "center" },
        { title: "服务费", dataIndex: "service_price", scopedSlots: { customRender: "service_price" }, width: 120, align: "center" },
        { title: "总电价", dataIndex: "total_price", scopedSlots: { customRender: "total_price" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 120, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      valid: true,
      pricevalid: true,
      model: false,
      pricemodel: false,
      modeltitle: "",
      pricemodeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {
        name: "",
        max_power: "",
        count: "",
        location: {},
        linkman: "",
        linkphone: "",
        remark: "",
      },
      priceform: {
        type: "",
        time_range: "",
        price: "",
        service_price: "",
        total_price: "",
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    swidth() {
      return _.reduce(this.sheaders, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclechargingpile/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getTypeText(type) {
      switch (type) {
        case 'peak':
          return '峰段';
        case 'flat':
          return '平段';
        case 'valley':
          return '谷段';
        case 'sh_peak':
          return '尖峰段';
        default:
          return '';
      }
    },
    showadd() {
      this.form = {
        _id: "",
        name: "",
        max_power: "",
        count: "",
        price: "",
        service_fee: "",
        location: {
          title: "",
          address: "",
          latitude: "",
          longitude: "",
        },
        linkman: "",
        linkphone: "",
        remark: "",
      };
      this.modeltitle = "新增充电桩";
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        name: item.name,
        max_power: item.max_power,
        count: item.count,
        price: item.price,
        service_fee: item.service_fee,
        location: item.location,
        linkman: item.linkman,
        linkphone: item.linkphone,
        remark: item.remark,
      };
      this.modeltitle = "编辑充电桩";
      this.model = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclechargingpile/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclechargingpile/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    chooseLocation() {
      this.$refs.mapRef.init({
        id: this.$utils.uuid(),
        open: true,
        title: "地图选点",
        form: {
          address: this.form.location.address,
        },
      });
      // let list = [];
      // if (this.form.location.latitude && this.form.location.longitude) {
      //   list.push({
      //     title: this.form.location.title || this.form.name,
      //     address: this.form.location.address,
      //     location: {
      //       lat: Number(this.form.location.latitude),
      //       lng: Number(this.form.location.longitude),
      //     },
      //   });
      // }
      // this.$nextTick(() => {
      //   this.$refs.mapRef.initMap({
      //     lat: this.form.location.latitude,
      //     lng: this.form.location.longitude,
      //     list,
      //   });
      // });
    },
    confirmLocation(data) {
      console.log('confirmLocation', data);
      this.form.location = {
        title: data.title,
        // address: data.address,
        latitude: data.location.lat,
        longitude: data.location.lng,
      };
    },
    showprice(record) {
      this.priceform = {
        _id: "",
        chargingpileid: record._id,
        type: "",
        time_range: "",
        price: "",
        service_price: "",
      };
      this.pricemodeltitle = "新增电费计价";
      this.pricemodel = true;
    },
    editprice(item) {
      this.priceform = {
        _id: item._id,
        chargingpileid: item.chargingpileid,
        type: item.type,
        time_range: item.time_range,
        price: item.price,
        service_price: item.service_price,
      };
      this.pricemodeltitle = "编辑电费计价";
      this.pricemodel = true;
    },
    saveprice() {
      if (!this.$refs.priceform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityfeeconfig/save", { dataForm: this.priceform }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.pricemodel = false;
          message.success("添加成功");
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsaveprice() {
      this.$refs.priceform.resetValidation();
      this.pricemodel = false;
    },
    copyprice(id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityfeeconfig/copy", { id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          message.success("复制成功");
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    removeprice(id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityfeeconfig/remove", { _id: id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          message.success("删除成功");
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
